import { useState } from 'react';

import { InsightEntity } from '../types/Insights';
import { httpPost } from '../../../../components/utils';

interface Params {
    selectedEntities: InsightEntity[];
    insightName: string;
    newStatus: string;
    newStatusDescription?: string;
    onSuccess?: () => void;
    onError?: (error?: any) => void;
}

const useMutateInsightEntityState = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccessful, setIsSuccessful] = useState(false);
    const [error, setError] = useState<any>(undefined);

    const mutateInsightEntityState = async ({
        selectedEntities,
        insightName,
        newStatus,
        newStatusDescription,
        onSuccess,
        onError
    }: Params) => {
        setIsLoading(true);
        setIsSuccessful(false);
        setError(undefined);

        try {
            const entitiesToUpdate = {
                ruleName: insightName,
                entities: selectedEntities
            };

            await httpPost('/insights/updateEntityInsight', {
                data: entitiesToUpdate,
                newStatus,
                newStatusDescription
            });
            setIsSuccessful(true);
            onSuccess?.();
        } catch (err: any) {
            setError(err);
            onError?.(err);
        }
        setIsLoading(false);
    };

    return { mutate: mutateInsightEntityState, isLoading, isSuccessful, error };
};

export default useMutateInsightEntityState;
